import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModalType, ModalTypeValue } from "enums/modalType";
import { ApplicationRootState } from "types";
import { masterStateType } from "types/master";

export const initialState: masterStateType = {
  clientCountryCode: "",
  openModal: ModalTypeValue.CLOSE,
  openSidebar: false,
  openSubModal: ModalTypeValue.CLOSE,
  openModalNoti: ModalType.CLOSE_NOTI,
  openModalNotiMobile: ModalType.CLOSE_NOTI_MOBILE,
  openModalForgot: ModalType.CLOSE_FORGOT,
};

const master = createSlice({
  name: "master",
  initialState,
  reducers: {
    setClientCountryCode(
      state: masterStateType,
      action: PayloadAction<string>,
    ) {
      localStorage.setItem("i18nLng", action.payload);
      state.clientCountryCode = action.payload;
    },
    setOpenModal(
      state: masterStateType,
      action: PayloadAction<ModalTypeValue>,
    ) {
      state.openModal = action.payload;
    },
    setOpenSubModal(
      state: masterStateType,
      action: PayloadAction<ModalTypeValue>,
    ) {
      state.openSubModal = action.payload;
    },
    setOpenSidebar(state: masterStateType, action: PayloadAction<boolean>) {
      state.openSidebar = action.payload;
    },
    setOpenModalNoti(state: masterStateType, action: PayloadAction<ModalType>) {
      state.openModalNoti = action.payload;
    },
    setOpenModalNotiMobile(
      state: masterStateType,
      action: PayloadAction<ModalType>,
    ) {
      state.openModalNotiMobile = action.payload;
    },
    setOpenModalForgot(
      state: masterStateType,
      action: PayloadAction<ModalType>,
    ) {
      state.openModalForgot = action.payload;
    },
  },
});

export const selectClientCountryCode = (state: ApplicationRootState) =>
  state.master.clientCountryCode;
export const selectOpenModal = (state: ApplicationRootState) =>
  state.master.openModal;
export const selectOpenSubModal = (state: ApplicationRootState) =>
  state.master.openSubModal;
export const selectOpenSidebar = (state: ApplicationRootState) =>
  state.master.openSidebar;
export const selectOpenNotiModal = (state: ApplicationRootState) =>
  state.master.openModalNoti;
export const selectOpenNotiMobileModal = (state: ApplicationRootState) =>
  state.master.openModalNotiMobile;
export const selectOpenForgotModal = (state: ApplicationRootState) =>
  state.master.openModalForgot;

export const {
  setClientCountryCode,
  setOpenModal,
  setOpenSubModal,
  setOpenSidebar,
  setOpenModalNoti,
  setOpenModalForgot,
  setOpenModalNotiMobile,
} = master.actions;

export default master.reducer;
